import { useState } from "react";
import type { PublicPrimaryImage } from "../api/types";

type ReleaseImageProps = {
  image: PublicPrimaryImage | null;
  alt: string;
  priority?: boolean;
  className?: string;
  size?: "card" | "detail";
};

export function ReleaseImage({
  image,
  alt,
  priority = false,
  className = "",
  size = "card",
}: ReleaseImageProps) {
  const [broken, setBroken] = useState(false);
  const showImage = image !== null && !broken;
  const isCard = size === "card";
  const src =
    isCard
      ? image?.thumbnailUrl || image?.originalUrl
      : image?.originalUrl;

  return (
    <div className={`hw-release-image ${className}`.trim()} aria-hidden={!showImage}>
      {showImage && src ? (
        <img
          src={src}
          alt={alt}
          loading={priority ? "eager" : "lazy"}
          decoding={isCard ? "sync" : "async"}
          referrerPolicy="no-referrer"
          width={image.width ?? undefined}
          height={image.height ?? undefined}
          onError={() => setBroken(true)}
        />
      ) : (
        <div className="hw-release-image__placeholder" role="img" aria-label={alt}>
          Нет фото
        </div>
      )}
    </div>
  );
}
